import sortPieveActivityEvents from '@/lib/activityEvents/sortPieveActivityEvents.js';
import { normalizePieveThreadEventsForPresentation } from '@/lib/pieveThreadEventNormalization.js';
import normalizeRemoteThreadEventForPresentation from '@/lib/threadEvents/normalizeRemoteThreadEventForPresentation.js';
import { reconcileToolCallEventsWithToolResults } from '@/lib/threadEvents/toolCallActivityHelpers.js';

const parseThreadEventsPageResponse = (payload = {}) => {
  const root = payload && typeof payload === 'object' ? payload : {};
  const data = root?.success === true && root?.data && typeof root.data === 'object' ? root.data : root;
  const rawEvents = Array.isArray(data) ? data : Array.isArray(data?.events) ? data.events : Array.isArray(data?.items) ? data.items : Array.isArray(data?.list) ? data.list : [];
  const normalizedEvents = normalizePieveThreadEventsForPresentation(
    rawEvents.flatMap((event) => {
      const normalizedEvent = normalizeRemoteThreadEventForPresentation(event);

      if (Array.isArray(normalizedEvent)) {
        return normalizedEvent.filter(Boolean);
      }

      return normalizedEvent ? [normalizedEvent] : [];
    })
  );
  const reconciledEvents = reconcileToolCallEventsWithToolResults(normalizedEvents);

  return {
    events: sortPieveActivityEvents(reconciledEvents),
    hasOlder: typeof data?.hasOlder === 'boolean' ? data.hasOlder : typeof data?.hasMoreOlder === 'boolean' ? data.hasMoreOlder : typeof data?.page?.hasOlder === 'boolean' ? data.page.hasOlder : typeof data?.page?.hasMore === 'boolean' ? data.page.hasMore : null
  };
};

export default parseThreadEventsPageResponse;
